<template>
  <div id="main-wrapper">
    <div v-if="store.trans_id && store.trans_id_type == 'INTERNAL TRANSFER'">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-center">
                <p>{{$t('account.received_your_request')}} {{static_vars.currency[store.lastSelectedAccount.currency]}}{{form.amount}} {{$t('account.from_trading_account')}} {{form.account_id}} {{$t('account.to')}} {{form.to_account_id}}. {{$t('account.to_confirm')}}</p>
                <SuccessBox
                    type="transfer"
                  />
              </div>
              <!-- <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="resetAndBack">OK </a>
              </div> -->
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="resetAndBack">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="message">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-center">
                <p v-if="msgType == 'success'">{{$t('account.internal_transfer_request')}} {{message.account_id}} {{$t('account.for_amount')}} {{static_vars.currency[message.to_currency]}} {{message.amount}} {{$t('account.to_account')}} {{message.to_account_id}} {{$t('account.was_succesfull')}} {{static_vars.currency[message.to_currency]}} {{message.to_amount}}.</p>
                <p v-else>{{message}}</p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="ChangeBalance(message.account_id);message = '' ">{{$t('account.ok')}} </a>
              </div>
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="ChangeBalance(message.account_id); message = ''">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-container profile-page manage-acct internal-transfer">
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="title-holder">
              <h4>{{$t('account.internal_transfer')}}</h4>
            </div>
            <div class="content-holder">
              <div class="row-sec">
                <div class="form-holder wow fadeInLeft">
                  <!-- <SuccessBox
                    v-if="
                      store.trans_id &&
                      store.trans_id_type == 'INTERNAL TRANSFER'
                    "
                    type="transfer"
                  /> -->
                  <Form @submit="submit">
                    <ul class="clearfix" data-select2-id="9">
                      <li class="half-width f-left">
                        <label for="">{{$t('account.transfer_From')}}</label>
                        <!-- <Field
                          class="form-control"
                          name="from_account"
                          rules="required"
                          v-slot="{ field }"
                          v-model="form.account_id"
                        >
                          <AccountsDropdown v-bind="field" />
                        </Field>
                        <ErrorMessage name="from_account" /> -->
                        <select class="form-control" name="from_account" v-model="form.account_id"  @change="changeToAccount">
                            <option value="" label="Select Trading ID">{{$t('account.select_trading_id')}}</option>
                            <!-- <optgroup label="Demo MT4">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('0','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Demo MT5">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('0','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup> -->
                            <optgroup label="Live MT4">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT5">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live ZTP">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','ZTP')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                        </select>
                         <ErrorMessage name="from_account" />
                      </li>
                      <li class="half-width f-right">
                        <label for="">{{$t('account.transfer_to')}}</label>
                        <Field
                          class="form-control"
                          as="select"
                          name="to_account"
                          rules="required"
                          v-model="form.to_account_id"
                        >
                          <option value="" disabled>
                            {{$t('account.select_trading_account')}}
                          </option>
                         <!--  <option
                            v-for="account of liveAccountsAvailable"
                            :value="account.account_id"
                            :key="account.account_id"
                          >
                            {{ account.account_id }} ({{
                              account.demo_live == "1" ? "Live" : "Demo"
                            }})
                          </option> -->
                            <option value="" label="Select Trading ID">{{$t('account.select_trading_id')}}</option>
                           <!--  <optgroup label="Demo MT4">
                              <option :value="list.account_id" v-for="list,index in TransferToMergeAcc('0','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Demo MT5">
                              <option :value="list.account_id" v-for="list,index in TransferToMergeAcc('0','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup> -->
                            <optgroup label="Live MT4">
                              <option :value="list.account_id" v-for="list,index in TransferToMergeAcc('1','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT5">
                              <option :value="list.account_id" v-for="list,index in TransferToMergeAcc('1','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live ZTP">
                              <option :value="list.account_id" v-for="list,index in TransferToMergeAcc('1','ZTP')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                        </Field>
                         <ErrorMessage name="to_account" />
                      </li>
                      <!-- <li class="half-width f-left">
                        <label for="">Max.</label>
                        <div class="currency">
                          <Field
                            name="max"
                            v-model="
                              store.tradingAccountDetail.margin_detail.balance
                            "
                            disabled
                          />
                          <div class="cur">
                            {{ store.lastSelectedAccount.currency }}
                          </div>
                        </div>
                      </li> -->
                      <li class="half-width f-left">
                        <label for="">{{$t('account.balance')}}</label>
                        <div class="currency">
                          <Field
                            name="balance"
                            v-model="store.tradingAccDetail.margin_detail.balance"
                            disabled
                          />
                          <div class="cur">
                            {{ toAccountCurrency }}
                          </div>
                        </div>
                      </li>
                      <li class="half-width f-right">
                        <div class="d-flex align-items-center justify-content-between">
                        <label for="">{{$t('account.enter_amount')}}</label>
                        <p class="mb-0 small" v-if="store.tradingAccDetail.margin_detail.balance">{{$t('account.USE_MAX')}} {{ store.tradingAccDetail.margin_detail.balance }}</p>
                      </div>
                        <div class="currency">
                          <Field
                            type="number"
                            name="transfer_amount"
                            :rules="amountRules"
                            v-model="form.amount "
                          />
                          <div class="cur">{{ store.lastSelectedAccount.currency }}</div>
                        </div>
                        <ErrorMessage name="transfer_amount" />
                      </li>
                    </ul>
                    <div class="btn-holder t-center">
                      <button class="btn btn-yellow popup-link-holder" :disabled="store.lastSelectedAccount.platform == 'ZTP' || ZtpAcc"> 
                        {{$t('account.proceed')}}
                      </button>
                      <a @click="$router.back()" class="btn btn-blue">{{$t('account.cancel')}}</a>
                    </div>
                    <span
                      class="text-danger"
                      v-if="
                      store.lastSelectedAccount.platform == 'ZTP' || ZtpAcc
                      "
                    >
                    {{$t('account.Internal_Transfer_ZIP')}}
                    </span>
                    <div class="note">
                      <p>{{$t('account.In_case_of_internal_transfer')}}</p>
                    </div>
                  </Form>
                </div>
                <div class="img-holder wow fadeInRight">
                  <img src="assets/images/internal-img.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";
import SuccessBox from "@/components/shared/SuccessBox";
//import AccountsDropdown from "@/components/shared/AccountsDropdown";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      toAccountCurrency: "USD",
      form: {
        account_id: "",
        to_account_id: "",
        amount: "",
        operation: "INTERNAL TRANSFER",
      },
      message : '',
      msgType : '',
      ZtpAcc : false,
    };
  },
  watch: {
    'form.to_account_id'(){
      if(this.form.to_account_id){
        let data = this.store.tradingAccounts.records.filter(i => i.account_id == this.form.to_account_id)[0]
        if(Object.keys(data).length && data.platform == 'ZTP'){
          this.ZtpAcc = true
        }else{
          this.ZtpAcc = false
        }
      }
    }
  },
  computed: {
    liveAccountsAvailable() {
        if(parseInt(this.store.lastSelectedAccount.demo_live) == 1){
            return this.store.liveAccounts.filter(
                (i) => i.account_id != this.form.account_id 
              );
        }else{
            return this.store.demoAccounts.filter(
                (i) => i.account_id != this.form.account_id 
              );
        }
    },
  },
  mounted() {
    console.log(this.store.lastSelectedAccount.account_id);
    this.form.account_id = this.store.lastSelectedAccount.account_id;
    this.changeToAccount();
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    SuccessBox,
    //AccountsDropdown,
  },
  methods: {
    MergeAcc(acc_type,platform){
        let demoMT4 = this.store.tradingAccounts.records.filter(i => i.demo_live == acc_type && i.platform == platform).map(val => val)
        return demoMT4 || []
    },
    TransferToMergeAcc(acc_type,platform){
      let demoMT4 = this.store.tradingAccounts.records.filter(i => i.demo_live == acc_type && i.platform == platform && i.account_id != this.form.account_id ).map(val => val)
        return demoMT4 || []
    },
    resetAndBack() {
      this.store.$patch({ trans_id: null });
      this.$router.back();
    },
    submit() {
      let form = this.form
      form.amount = (this.form.amount || 0).toString()
      this.store.accountOperations(this.form, true);
    },
    resend() {
      let form = {
        trans_id: this.store.trans_id,
      };
      this.store.resendOperationsLink(form, true);
    },
    verify() {
      let form = {
        type: this.form.operation,
        google_token: this.google_token,
        trans_id: `${this.store.trans_id}`,
      };
      this.store.verifyAccountOperation(form, true).then(response => {
        //modal show
        this.store.$patch({ trans_id: null });
        this.message = response
        this.msgType = 'success'
      }).catch(error => {
        this.store.$patch({ trans_id: null });
        this.message = error
        this.msgType = 'error'
      })
    },
    amountRules(value) {
      if(value){
        if (parseFloat(value) > parseFloat(this.store.tradingAccDetail.margin_detail.balance)) {
          return "Transfer amount should not be greater than available balance";
        }
        return true;
      }else{
        return "Amount is required"
      }
    },
    // changeFromAccount() {
    //   let account = this.store.tradingAccounts.records.filter(
    //     (i) => i.account_id === e.target.value
    //   );
    //   this.store.setLastSelectedAccount(account[0]);
    // },
    ChangeBalance(id){
      if(this.msgType == 'success'){
        let account = this.store.tradingAccounts.records.filter(
        (i) => i.account_id === id
      );
      let keys = {
        dataRequired: {
          margin_detail: true,
          open_trades: false,
          history: false,
          account_detail: false,
        },
      };
      this.toAccountCurrency = account[0].currency;
      this.store.setLastSelectedAccount(account[0],keys,false,'')
      this.form.to_account_id = ''
       this.store.$patch( this.store.tradingAccDetail =  {
          "open_trades": {},
          "open_orders": {},
          "margin_detail": {},
          "history": {}
        });
       this.form.amount = ''
      }
    },
    changeToAccount() {
      let account = this.store.tradingAccounts.records.filter(
        (i) => i.account_id === this.form.account_id
      );
      let keys = {
        dataRequired: {
          margin_detail: true,
          open_trades: false,
          history: false,
          account_detail: false,
        },
      };
      this.toAccountCurrency = account[0].currency;
      this.store.setLastSelectedAccount(account[0],keys,false,'internal-transfer')
    },
  },
};
</script>
